/** Hauteur fixe du header site (alignée design system / DefaultHeader topThreshold). */
const SITE_HEADER_OFFSET_PX = 64;

/** Scroll vers le bloc widget suivant, avec offset header si navbar présente. */
export function scrollToNextLandingBlock(templateSelector: string) {
  if (typeof document === "undefined") return;

  const instance = document.querySelector(templateSelector);
  const next = instance?.nextElementSibling;
  if (!(next instanceof HTMLElement)) return;

  const navbar = document.querySelector(".default-header");
  const offset = navbar ? SITE_HEADER_OFFSET_PX : 0;

  window.scrollTo({
    top: next.getBoundingClientRect().top + window.scrollY - offset,
    behavior: "smooth",
  });
}
